import {
    CTRL_SOCIETY_DROPDOWN,
    CTRL_EMPLOYEE_LIST,
    CTRL_EMPLOYEE_DIRECTORY,
    CTRL_EMPLOYEE_STATS,
    CTRL_EMPLOYEE_DETAILS,
    CTRL_EMPLOYEE_SOCIETIES,
    CTRL_ASSIGN_EMPLOYEE_SOCIETY,
    CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE,
    CTRL_CREATE_EMPLOYEE,
    CTRL_UPDATE_EMPLOYEE,
    CTRL_DELETE_EMPLOYEE,
    CTRL_BULK_STATUS_EMPLOYEE,
    CTRL_BULK_REASSIGN_EMPLOYEE,
    CTRL_SEARCH_EMPLOYEE_BY_EMAIL,
    CTRL_CLEAR_EMPLOYEE_SEARCH,
    CTRL_LINK_EXISTING_EMPLOYEE,
    CTRL_EMPLOYEE_TYPES_DROPDOWN,
    CTRL_EMPLOYEE_ROLE_LIST,
    CTRL_EMPLOYEE_ROLE_DETAILS,
    CTRL_CREATE_EMPLOYEE_ROLE,
    CTRL_UPDATE_EMPLOYEE_ROLE,
    CTRL_DELETE_EMPLOYEE_ROLE,
} from '../../index.types';

// ---- Society dropdown (scoped, lightweight) ----
export const getSocietyDropdown = (data) => ({ type: CTRL_SOCIETY_DROPDOWN, data });

// ---- Employees (cross-society directory) ----
export const getEmployeesList = (data) => ({ type: CTRL_EMPLOYEE_LIST, data });
export const getEmployeeDirectory = (data) => ({ type: CTRL_EMPLOYEE_DIRECTORY, data });
export const getEmployeeStats = (data) => ({ type: CTRL_EMPLOYEE_STATS, data });
export const getEmployeeDetails = (data) => ({ type: CTRL_EMPLOYEE_DETAILS, data });
export const getEmployeeSocieties = (data) => ({ type: CTRL_EMPLOYEE_SOCIETIES, data });
export const assignEmployeeSociety = (data) => ({ type: CTRL_ASSIGN_EMPLOYEE_SOCIETY, data });
export const changeEmployeeSocietyRole = (data) => ({ type: CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE, data });
export const createEmployee = (data) => ({ type: CTRL_CREATE_EMPLOYEE, data });
export const updateEmployee = (data) => ({ type: CTRL_UPDATE_EMPLOYEE, data });
export const deleteEmployee = (data) => ({ type: CTRL_DELETE_EMPLOYEE, data });
export const bulkStatusEmployee = (data) => ({ type: CTRL_BULK_STATUS_EMPLOYEE, data });
export const bulkReassignEmployee = (data) => ({ type: CTRL_BULK_REASSIGN_EMPLOYEE, data });
export const searchEmployeeByEmail = (data) => ({ type: CTRL_SEARCH_EMPLOYEE_BY_EMAIL, data });
export const clearEmployeeSearch = () => ({ type: CTRL_CLEAR_EMPLOYEE_SEARCH });
export const linkExistingEmployee = (data) => ({ type: CTRL_LINK_EXISTING_EMPLOYEE, data });
export const getEmployeeTypesDropdown = (data) => ({ type: CTRL_EMPLOYEE_TYPES_DROPDOWN, data });

// ---- Employee Types (roles) catalog ----
export const getEmployeeRoles = (data) => ({ type: CTRL_EMPLOYEE_ROLE_LIST, data });
export const getEmployeeRoleDetails = (data) => ({ type: CTRL_EMPLOYEE_ROLE_DETAILS, data });
export const createEmployeeRole = (data) => ({ type: CTRL_CREATE_EMPLOYEE_ROLE, data });
export const updateEmployeeRole = (data) => ({ type: CTRL_UPDATE_EMPLOYEE_ROLE, data });
export const deleteEmployeeRole = (data) => ({ type: CTRL_DELETE_EMPLOYEE_ROLE, data });
